const motionButton = document.querySelector('#motion-toggle');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
let motionPaused = reducedMotion.matches;
function setMotion(paused) {
  motionPaused = paused;
  document.body.classList.toggle('motion-enabled', !paused);
  document.body.classList.toggle('motion-paused', paused);
  motionButton.setAttribute('aria-pressed', String(paused));
  motionButton.textContent = paused ? 'Enable motion' : 'Pause motion';
  const film = document.getElementById('melt-film');
  if (film && paused) film.pause();
  if (film && !paused && film.getBoundingClientRect().top < innerHeight && film.getBoundingClientRect().bottom > 0) film.play().catch(() => {});
}
const revealObserver = new IntersectionObserver(entries => {
  for (const entry of entries) if (entry.isIntersecting) {
    entry.target.classList.add('is-visible');
    revealObserver.unobserve(entry.target);
  }
}, {threshold: 0.1});
document.querySelectorAll('.benefits>div,.product-copy,.how>.eyebrow,.how>h2,.steps article,.review-editorial,.story>div:last-child,.routine-intro,.routine-options article,.faq>div,.closing>h2').forEach((element,index) => {
  element.classList.add('reveal');
  element.style.setProperty('--reveal-delay', `${element.closest('.steps, .benefits') ? index % 3 * 100 : 0}ms`);
  revealObserver.observe(element);
});
setMotion(motionPaused);
motionButton.addEventListener('click', () => setMotion(!motionPaused));
reducedMotion.addEventListener('change', event => setMotion(event.matches));
const hero = document.querySelector('.hero');
const story = document.querySelector('.story');
const shop = document.querySelector('#shop');
const mobileShop = document.querySelector('.mobile-shop');
let scrollPending = false;
function updateScroll() {
  scrollPending = false;
  const height = document.documentElement.scrollHeight - window.innerHeight;
  document.documentElement.style.setProperty('--progress', height > 0 ? window.scrollY / height : 0);
  const heroRect = hero.getBoundingClientRect();
  const shopRect = shop.getBoundingClientRect();
  mobileShop.classList.toggle('is-visible', heroRect.bottom < 0 && (shopRect.bottom < 0 || shopRect.top > window.innerHeight));
  if (motionPaused) return;
  const storyRect = story.getBoundingClientRect();
  const clamp = (value,min,max) => Math.min(max,Math.max(min,value));
  hero.style.setProperty('--hero-y', `${clamp(-heroRect.top * .055,-15,30)}px`);
  story.style.setProperty('--story-r', `${clamp((storyRect.top - window.innerHeight / 3) * .006,-3,3)}deg`);
}
window.addEventListener('scroll', () => { if (!scrollPending) { scrollPending = true; requestAnimationFrame(updateScroll); } }, {passive:true});
window.addEventListener('resize', updateScroll, {passive:true});
updateScroll();

const film = document.getElementById('melt-film');
const filmObserver = new IntersectionObserver(entries => {
  for (const entry of entries) {
    if (entry.isIntersecting && !motionPaused) film.play().catch(() => {});
    else film.pause();
  }
}, {threshold:.2});
if (film) filmObserver.observe(film);
